import React from 'react'
import styled from 'styled-components'

interface InlineIconProps {
  width?: string
  height?: string
  title?: string
  children?: string
}

const SVG = styled.svg`
  width: ${(props) => props.width || '25px'};
  height: ${(props) => props.height || '25px'};
  fill: ${(props) => props.fill || 'none'};
  stroke: ${(props) => props.stroke || 'none'};
`

/* 
  Using svg as InlineIcon
   <InlineIcon danger={danger2}>{Sun}</InlineIcon>
*/

export const InlineIcon = (props: InlineIconProps): React.ReactElement => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 20 20"
    {...props}
  >
    <title>{props.title}</title>
    <path d={props.children} />
  </SVG>
)
